import type { SysProject } from '@/types/common';
import { createVNode, render } from 'vue';
import FormGeneratorModalVue from './index.vue';

export type CommonProjectSwitchOptions = {
  disabled?: number | number[]; // project id
  onProjectEntry: (p: SysProject) => void;
};

export default function showCommonProjectSwitch(
  opts: CommonProjectSwitchOptions,
) {
  const container = document.createElement('div');
  const onClose = () => {
    document.body.removeChild(container);
  };
  const vNode = createVNode(FormGeneratorModalVue, {
    onClose,
  });
  render(vNode, container);
  const instance = vNode.component;
  document.body.appendChild(container);
  instance.exposed.show(opts);
}
